/** Mirrors backend App\Support\ProductUnits::ALLOWED */
export const PRODUCT_UNITS = [
  { value: 'pcs', label: 'Pieces (pcs)' },
  { value: 'bag', label: 'Bag' },
  { value: 'metre', label: 'Metre (m)' },
  { value: 'kg', label: 'Kilogram (kg)' },
  { value: 'litre', label: 'Litre' },
  { value: 'roll', label: 'Roll' },
  { value: 'box', label: 'Box' },
  { value: 'strip', label: 'Strip (tablets)' },
  { value: 'bottle', label: 'Bottle' },
  { value: 'tube', label: 'Tube' },
  { value: 'sachet', label: 'Sachet' },
  { value: 'vial', label: 'Vial / ampoule' },
  { value: 'tonne', label: 'Tonne' },
  { value: 'lorry', label: 'Lorry (gari la mchanga)' },
  { value: 'set', label: 'Set' },
  { value: 'other', label: 'Other' },
];

export function productUnitLabel(unit) {
  const found = PRODUCT_UNITS.find((u) => u.value === unit);
  return found?.label?.split(' (')[0] || unit || 'pcs';
}

/** Whole-number display for factory raw-material stock (bags, lorry, pcs…). */
export function formatFactoryStockQty(qty) {
  const n = Number(qty);
  if (!Number.isFinite(n)) return '—';
  return Math.round(n).toLocaleString('en-TZ');
}

/** e.g. "120 Bag" or "4.5 Tonne" */
export function formatQtyWithUnit(qty, unit) {
  const n = Number(qty);
  const val = Number.isFinite(n) ? n.toLocaleString() : '—';
  const label = productUnitLabel(unit);
  return `${val} ${label}`;
}

/** Factory raw materials — always whole numbers with unit label. */
export function formatFactoryQtyWithUnit(qty, unit) {
  const val = formatFactoryStockQty(qty);
  if (val === '—') return val;
  return `${val} ${productUnitLabel(unit)}`;
}

/** e.g. "per bag" for price labels */
export function unitPerLabel(unit) {
  const label = productUnitLabel(unit).toLowerCase();
  return `per ${label}`;
}

export function quantityHintForUnit(unit) {
  const u = unit || 'pcs';
  if (u === 'metre') return 'Length in metres';
  if (u === 'kg' || u === 'tonne') return 'Weight';
  if (u === 'litre') return 'Volume in litres';
  if (u === 'lorry') return 'Number of lorry loads delivered';
  if (u === 'bag' || u === 'box' || u === 'roll' || u === 'strip' || u === 'sachet') return 'Number of units';
  if (u === 'bottle' || u === 'tube' || u === 'vial') return 'Number of packs / bottles';
  return 'Quantity in stock';
}
